import { createContext } from 'react';
import { IdToken } from '@auth0/auth0-react';

export interface UserAuthenticatedProps {
  setUserAuthenticated: (status: IdToken | null) => void;
}

export const UserAuthenticatedContext = createContext<UserAuthenticatedProps>({
  setUserAuthenticated: () => {},
});
